import { Component, Vue } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';
import {Iuser} from '@/types/iUser';
import User from "@/module/store/user"
import Nomenclatures from "@/module/store/nomenclatures"
import { LocalStorage } from 'quasar';
import UserRegister from "@/views/UserRegister/UserRegister";
import {CONFIG_ENV} from '@/config';
import  {getProfileImgAsString}  from '@/module/utils';
import {I_List} from "@/types/iList";
import {slugify} from "@/module/utils";
import { scrollToElementById } from '@/module/utils';
/*
var MockAdapter = require('axios-mock-adapter');
var mock = new MockAdapter(axios);
mock.onGet('/loadApp').reply(200, {
    userData:{ username:'Florin Codreanu',
        id:'florin.codreanu@bcr.ro',
        empno:12789}
});
*/

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
//axios.defaults.headers.common['X-CSRF-TOKEN'] = '1t6bh0lwh72pv.2k9aurnh5tk44';

@Component({components:{UserRegister}})
export default class App extends Vue {
    myBoolTrue:boolean=true;
    myBoolFalse:boolean=false;
    loadingApp:boolean=false;
    lastPublicLists:Array<I_List>=[];
    ShowLeftDrawer:boolean=false;
    ShowRightDrawer:boolean=false;
    footerClientiTestimonyals:Array<any>=[
        {client_name:'Alex',testimony:'A fost foarte usor sa lucrez cu acest portal. Lucrurile au mers bine'}
        ,{client_name:'Mihaela',testimony:'A fost foarte usor sa lucrez cu acest portal. Lucrurile au mers bine'}
    ];
    footerInstagramTestimonyals:Array<any>=[
        {img_url:'/pages/captureinstagram1.png'},
        {img_url:'/pages/captureinstagram2.png'},
        {img_url:'/pages/captureinstagram3.png'}
    ];
    private userStore=getModule(User);
    private nomenclaturesStore=getModule(Nomenclatures);
    $refs:any;

    constructor(){
        super();
    }

    goToAutentificare(){
        scrollToElementById('img_logo_site',0,300);
        this.$router.push({ name: 'autentificare' });
    }

    goToInregistrare(){
        scrollToElementById('img_logo_site',0,300);
        this.$router.push({ name: 'user_register' });
    }

    goToNewList(){
        scrollToElementById('img_logo_site',0,300);
        this.$router.push({ name: 'new_gifts_list' });
    }

    handleSwipeFooter ({ evt, ...info }:any) {
        let vueInst=this;
        //console.log('vueInst.$router.currentRoute=%o',vueInst.$router.currentRoute);
        if(info.direction=='up'){//prev Page
            scrollToElementById('div_follow_me_on_instagram',-22,300);
        }
        if(info.direction=='down'){//prev Page
            const el_div_alege_sa_te_implici: HTMLElement | null = document.getElementById('div_alege_sa_te_implici');

            if (el_div_alege_sa_te_implici) {
                scrollToElementById('div_alege_sa_te_implici',-12,300);
            }
            else{
                //scrollToElementById('img_logo_site',0,300);
                window.scrollBy(0, -200);
            }

        }
    }

    logout(){
        LocalStorage.set('isAuthenticated', 'no');
        LocalStorage.set('token_for_permanent_session', 'x');
        LocalStorage.set('userid', '0');
        this.$q.notify({
            color: 'purple',
            textColor: 'white',
            position:'top-right',
            timeout: 1000,
            icon: 'fas fa-exclamation-triangle',
            message: 'Ati fost delogat de la aplicatie!'
        });
        this.$router.push({ name: 'home' });
        this.userStore.set_user({
            userid:'0',
            email:'',
            lastName:'',
            firstName:'',
            isEmailChecked:true,
            isAuthenticated:false,
            csrf_token:'x'});
    }

    goHomeSite(){
        this.$router.push({ name: 'home' });
        var el: HTMLElement | null = document.getElementById('img_logo_site');
           if(el){
               scrollToElementById('img_logo_site',0,0);
           }
    }

    loadNomenclatures(){
        const vueInst=this;
        if (typeof(Worker) !== "undefined") {
            // Yes! Web worker support!
            var myWorkerNomenclatures = new Worker("/js/workers/ww_load_nomenclatures.js");
            myWorkerNomenclatures.onmessage = function(event) {
                switch (event.data.cmd){
                    case 'getNomCategOfEvents':
                        vueInst.nomenclaturesStore.set_nom_categ_of_events(event.data.nom_categ_of_events);
                        break;
                    case 'getNomTypesOfEvents':
                        vueInst.nomenclaturesStore.set_nom_types_of_events(event.data.nom_types_of_events);
                        break;
                }
            };
            myWorkerNomenclatures.postMessage({cmd: 'getNomCategOfEvents'});
            myWorkerNomenclatures.postMessage({cmd: 'getNomTypesOfEvents'});
        } else {
            // Sorry! No Web Worker support..
        }
    }

    openAPublicList(plistid:I_List){
        //console.log('slugify(plistid.list_name)=%o',slugify(plistid.list_name))
        this.$router.push({ name: 'view_public_list', params: { m:'v', listid: plistid.listid.toString(),token_lista:plistid.token_pt_acces_lista,list_name_as_link:slugify(plistid.list_name) } });
        scrollToElementById('img_logo_site',0,300);
    }

    async loadLastPublicLists(){
        const vueInst=this;
        let res = await axios.get(`${CONFIG_ENV.URL_PUBLIC_INFO.get_last_public_lists}`);
        let data = await res.data;
        if(res.data.status=='success'){
            vueInst.lastPublicLists=res.data.lists;
        }
    }

    async getTokenForPermanentSession(userid:string,token_for_permanent_session:string){
        var params = new URLSearchParams();
        params.append('token_for_permanent_session', token_for_permanent_session);
        params.append('userid', userid);
        let res = await axios.post(`${CONFIG_ENV.URL_USER.check_token_for_permanent_session}`,params,{timeout:5000});
        return res;
    }
    loadApp(){
        const vueInst=this;
        //console.log('%cloadApp where this.$route=%o and window.location.pathname=%o','color:blue; font-size:20px;',vueInst.$route.path,window.location.pathname);

        let isUserAuthenticated = LocalStorage.getItem('isAuthenticated');
        let token_for_permanent_session = LocalStorage.getItem('token_for_permanent_session');
        let userid = LocalStorage.getItem('userid');
        if(isUserAuthenticated && isUserAuthenticated=='yes'){
            //console.log('%cSe pare ca este autentificat, totusi verificam tokenul cu cel de per server!...','color:blue; font-size:20px;');
            vueInst.$q.loading.show({
                message: 'Se verifica autenticitatea userului!...'
            });
            this.loadingApp=true;
            vueInst.getTokenForPermanentSession(userid,token_for_permanent_session)
                .then(presponse=>{
                    vueInst.$q.loading.hide();
                    if(presponse.data.status=="success"){
                //console.log('%cSetez Autenticitatea pe True','color:blue; font-size:20px;');
                vueInst.userStore.set_user({
                    userid:presponse.data.userid,
                    email:presponse.data.email,
                    lastName:presponse.data.lastName,
                    firstName:presponse.data.firstName,
                    isEmailChecked:presponse.data.emailIsChecked,
                    isAuthenticated:true,
                    csrf_token:''
                });

                if(presponse.data.emailIsChecked=='y'){
                    LocalStorage.set('emailIsChecked', 'yes');
                    getProfileImgAsString(presponse.data.userid).then((response:any)=>{
                        LocalStorage.set('MyImgProfileString64', response.data);
                        vueInst.userStore.set_myimgprofilestring64r(response.data);
                    });
                    //console.log('%cNow go to my_home_page, even the window.location.href= and arrHref=%o', 'color:blue; font-size:20px;', window.location.href,arrHref);

                    /*
                    if(window.location.pathname.indexOf('/view_public_list/') !== -1)
                    {
                        let arrHref=window.location.pathname.substring(1).split("/");
                        vueInst.$router.push({name: 'view_public_list', params:{listid:arrHref[1],list_name_as_link:arrHref[2]}});
                    }
                    else {
                        vueInst.$router.push({name: 'my_home_page'})
                    }
                    */
                }
                    else{//nu are mailul verificat
                        vueInst.$router.push({name: 'bine_ai_venit'})
                    }

                    }else{//tokenul nu este valabil
                        LocalStorage.set('isAuthenticated', 'no');
                        LocalStorage.set('token_for_permanent_session', 'x');
                        LocalStorage.set('userid', '0');
                        this.$router.push({ name: 'home' });
                    }
                })
                .catch(e => {vueInst.$q.loading.hide()
                    console.log(e.message);
                    vueInst.$q.notify({
                        color: 'red',
                        textColor: 'white',
                        position:'top-right',
                        timeout: 3000,
                        icon: 'fas fa-exclamation-triangle',
                        message: e.message
                    });
                });

        }else{
            let arrHref=window.location.pathname.substring(1).split("/");
            LocalStorage.set('isAuthenticated', 'no');
            LocalStorage.set('token_for_permanent_session', 'x');
            LocalStorage.set('userid', '0');
            /*
           if(arrHref[0]=='autentificare_after_validare_email'){

           }

           else{
               if(window.location.pathname.indexOf('/view_public_list/') !== -1)
               {
                   let arrHref=window.location.pathname.substring(1).split("/");
                   vueInst.$router.push({name: 'view_public_list', params:{listid:arrHref[1],list_name_as_link:arrHref[2]}});
               }
               else{
                   this.$router.push({ name: 'home' });
               }

           }
           */
        }

    };

  runAfterEventAuthentication(){
    this.loadLastPublicLists();
  }
    GoToPageTest(){
        this.$router.push({ name: 'test' })
    }

    GoToPageCadouri(){
        this.$router.push({ name: 'cadouri' })
    }

    GoToPageDonatii(){
        this.$router.push({ name: 'donatii' })
    }

    goToMyProfile(){
        scrollToElementById('img_logo_site',0,100);
        this.$router.push({ name: 'myprofile' });
    }

    get user():Iuser{
        return this.userStore.user;
    }

    get MyImgProfileString64():string{
        return this.userStore.MyImgProfileString64;
    }
    created():void{
        this.loadNomenclatures();
        this.loadApp();
        this.loadLastPublicLists();
        this.$root.$on('eventFromAutentificare', this.runAfterEventAuthentication)
    }

}
